export const categories = [
  { name: 'Quran',   category:"Quran",  icon:"https://cdn.lordicon.com/mfqgdxxm.json"},
  { name: 'El-zero', category:"El-zero",  icon:"https://cdn.lordicon.com/dtgezzsi.json"},
  { name: 'UniqeCoder',     category:"unique coderz academy",  icon:"https://cdn.lordicon.com/anihkfxp.json"},
  // { name: 'Cooding',     category:"",  icon:""},
  { name: 'ReactJS', category:"ReactJS",  icon:"https://cdn.lordicon.com/dtgezzsi.json"},
  // { name: 'NextJS', category:"",  icon:""  },
  { name: 'Education',     category:"Education web development",  icon:"https://cdn.lordicon.com/wxnxiano.json"},
  { name: 'Podcast', category:"Ahmed  abo zied podcast",  icon:"https://cdn.lordicon.com/fpipqhrr.json" },
  { name: 'Football', category:"football ",  icon:"https://cdn.lordicon.com/qoozyitg.json"},
  { name: 'Gaming', category:"Football Gaming ",  icon:"https://cdn.lordicon.com/ktxpktdd.json" },
  { name: 'Live', category:"Palastine Live  ",  icon:"https://cdn.lordicon.com/smeqxwcv.json"},
  { name: 'Sunnah', category:"Sunnah",  icon:"https://cdn.lordicon.com/jfloqxvk.json" },
  // { name: 'AI', category:"",  icon:""},
  // { name: 'Sunnah', category:"",  icon:"" },
  // { name: 'Hadeth', category:"",  icon:"" },
  // { name: 'Gym', category:"",  icon:"https://cdn.lordicon.com/wibomifa.json" },
  { name: 'Muslims', category:"Muslim story", icon:"https://cdn.lordicon.com/wxnxiano.json" },
];